import CheckboxGroupWrapper from './CheckboxGroupWrapper';
import Controller from './Controller';

export type { CheckboxGroupProps } from './CheckboxGroup.types';

export default Object.assign(CheckboxGroupWrapper, {
  Controller,
});
